export const hideOnMobile = { display: { xs: 'none', sm: 'flex', md: 'flex', lg: 'flex' } };
export const showOnMobile = { display: { xs: 'flex', sm: 'none', md: 'none', lg: 'none' } };
